import SlideBuilderDrawer from './SlideBuilderDrawer';

export default SlideBuilderDrawer;
